<template>
  <v-layout row wrap form-padding class="contact-row">
    <v-flex xs5>
      <v-text-field
        class="form-input-box"
        label="Nome"
        :title="contato.nome"
        v-model="contato.nome"
        :readonly="!hasPermission('nome', contato)"
        placeholder=" "
      ></v-text-field>
    </v-flex>
    <v-flex xs3>
      <v-text-field
        class="form-input-box"
        label="Telefone"
        :title="contato.telefone"
        placeholder=" "
        v-model="contato.telefone"
        :rules="[
          (v) =>
            (!!v && v.length > 13) || 'Este número de telefone não é válido!',
        ]"
        :readonly="!hasPermission('nome', contato)"
        v-the-mask="['(##) #####-####', '(##) ####-####']"
      ></v-text-field>
    </v-flex>
    <v-flex xs4>
      <v-text-field
        class="form-input-box"
        label="Email"
        v-model="contato.email"
        :title="contato.email"
        :rules="[
          (v) =>
            /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
            'E-mail tem que ser válido',
          (v) => {
            return (
              usedEmails.filter((item) => item === v).length === 1 ||
              'E-mail já foi utilizado'
            );
          },
        ]"
        :readonly="!hasPermission('email', contato)"
        placeholder=" "
      ></v-text-field>
    </v-flex>

    <v-flex xs3 pb-0>
      <v-select
        class="form-select-box"
        label="Perfil"
        v-model="contato.perfil"
        placeholder="Selecionar "
        :rules="[(v) => !!v || 'Este campo deve ser preenchido!']"
        :readonly="!hasPermission('perfil', contato)"
        :items="
          contato.perfil === ADMIN_SUSEP
            ? niveisPerfis
            : niveisPerfis.filter((item) => item.value !== ADMIN_SUSEP)
        "
        :item-value="'value'"
        :item-text="'name'"
      ></v-select>
    </v-flex>
    <v-flex xs4 offset-xs5 d-inline-flex pb-0>
      <v-layout justify-end px-0 py-0>
        <v-flex
          xs4
          py-0
          pl-0
          v-if="
            model.perfil !== CORRETOR &&
            contato.perfil !== ADMIN_SUSEP &&
            !contato.justCreated
          "
        >
          <label
            class="switch-label"
            v-html="contato.bloqueado ? 'Bloqueado' : 'Desbloqueado'"
          />
          <v-switch
            class="block-switch"
            v-model="contato.bloqueado"
            @click.native="toggleBlocked(contato)"
            :readonly="!hasPermission('bloqueado', contato)"
          ></v-switch>
        </v-flex>
        <!-- esse v-flex só aparece se uma das duas condições
        do seu filho forem alimentadas-->
        <v-flex
          xs4
          py-0
          v-if="
            (model.perfil !== CORRETOR &&
              contato.perfil !== ADMIN_SUSEP &&
              !contato.justCreated) ||
            (contato.email !== model.email && contato.justCreated)
          "
        >
          <button
            v-if="
              model.perfil !== CORRETOR &&
              contato.perfil !== ADMIN_SUSEP &&
              !contato.justCreated
            "
            class="button jns-button white-button mt-3"
            @click="
              contactToDelete = contato;
              confirmDeleteModal = true;
            "
            :readonly="!hasPermission('bloqueado', contato)"
          >
            Remover
          </button>

          <button
            v-if="contato.email !== model.email && contato.justCreated"
            class="button jns-button white-button mt-3"
            @click.prevent="removeContactOnlyFromClient(contato)"
          >
            Remover
          </button>
        </v-flex>
        <v-flex xs4 py-0 pr-0 v-if="model.perfil !== CORRETOR">
          <button
            v-if="contato.hasOwnProperty('justCreated')"
            class="button jns-button yellow-button full-width mt-3"
            @click.prevent="insertContact(contato, true, index)"
          >
            Inserir
          </button>
          <button
            v-if="
              hasPermission('salvar', contato) &&
              !contato.hasOwnProperty('justCreated')
            "
            class="button jns-button yellow-button full-width mt-3"
            @click.prevent="updateContact(contato, true, index)"
          >
            Salvar
          </button>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<style lang="scss" scoped>
#jns {
  .contact-row {
    border-bottom: 1px solid #eee;
  }
}
</style>


<script lang="js">
import config from "@/../config";
import ViewMixin from "@/mixins/ViewMixin";
import { mask } from "vue-the-mask";
import settings from "@/app.settings";

const [ADMIN, ADMIN_SUSEP, CORRETOR] = settings.niveisPerfil.map(
  (item) => item.value
);

const permissionLevels = {
  [CORRETOR]: 1,
  [ADMIN]: 2,
  [ADMIN_SUSEP]: 3,
};
export default {
  name: "Contact",
  directives: { "the-mask": mask },
  mixins: [ViewMixin],
  data: () => ({
    model: {
      id: "",
      id_pessoa_corretor: "",
      id_pessoa_contato: "",
      nome: "",
      email: "",
      telefone: "",
      perfil: "",
      bloqueado: "",
      corretor: {
        id: "",
        id_pessoa: "",
        cnpj_cpf: "",
        nome: "",
        telefone: "",
        email: "",
        situacao_susep: "",
        simples_nacional: null,
        cpom: null,
        endereco: {
          cep: "",
          uf: "",
          logradouro: "",
          bairro: "",
          cidade: "",
        },
        informacao_bancaria: {
          conta: "",
          agencia: "",
          banco: "",
          nome_responsavel: "",
          cpf_responsavel: "",
        },
        contatos: [],
      },
    },
  }),
  
};
</script>



// WEBPACK FOOTER //
// ./src/components/Contact.vue